/**
 * @generated SignedSource<<2dc03c10ddbf047aaf3ebddbea3cfd05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleAcknowledgementGateOverlayArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "articleAcknowledgementGateOverlayArticle";
};
export type articleAcknowledgementGateOverlayArticle$key = {
  readonly " $data"?: articleAcknowledgementGateOverlayArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleAcknowledgementGateOverlayArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleAcknowledgementGateOverlayArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "40db9f9b1c9a90736fef6941fe230a8d";

export default node;
